import React from 'react';
import PropTypes from 'prop-types';
import overrideStyle from 'lib/overrideStyle';

import { getSelfServiceSearchResults } from 'app/modules';
import SearchResultsItem from 'presentation/selfService/SearchResultsItem';

const DropDown = overrideStyle('div')`
  flex: 1;
  overflow: auto;
`;

export default class SearchResults extends React.Component {
  constructor(props) {
    super(props);

    SearchResults.propTypes = {
      currentFocusIndex: PropTypes.number.isRequired,
      searchResults: PropTypes.array,
      shouldShowDropDown: PropTypes.bool,
      value: PropTypes.string.isRequired,
    };
  }

  render() {
    if (this.props.searchResults.length > 0) {
      return (
        <DropDown>
          {this.props.searchResults.map((answer, currentIndex) => (
            <SearchResultsItem
              answerId={answer.id}
              focused={currentIndex === this.props.currentFocusIndex}
              isSearchedAnswer={true}
              key={answer.id}
              name={answer.name.toString()}
              onBlur={this.props.onBlur}
            />
          ))}
        </DropDown>
      );
    } else {
      return null;
    }
  }
}
